import { h, Component } from 'preact';
import React from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import data from 'backend-data/index.js.erb';
import shopifyData from 'embed/shopifyData';
import { isCartPage } from '../helpers';

class PrepareCartForOffers extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount() {
    const userSettings = this.props.userSettings;

    let cartToken = ((window.MakeAnOffer || {}).config || {}).cart_token;
    let offers = (!!Cookies.get('mf_offers') ? JSON.parse(Cookies.get('mf_offers')) : []);
    let requestData = { cartToken: cartToken, offers: offers };
    let updateUrl = `${data.protocol}://${data.hostUrl}/offers/update_shopify_cart`;

    axios.post(updateUrl, requestData)
      .then((response) => {
        console.log(response);
      });
  }

  render(props, state) {
  }
}

export default PrepareCartForOffers;
